
import { UseFormRegister } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { FormData } from '../types';

interface YearsInBusinessFieldProps {
  register: UseFormRegister<FormData>;
}

export const YearsInBusinessField = ({ register }: YearsInBusinessFieldProps) => {
  return (
    <div>
      <Label htmlFor="years_in_business">Years in Business (if verified)</Label>
      <Input
        id="years_in_business"
        type="number"
        min="0"
        {...register('years_in_business', {
          valueAsNumber: true
        })}
      />
    </div>
  );
};
